const initState = {
    addSuccess: false,
    updateSuccess: false,
    
}

const machineReducer = (state = initState,action) => {
    switch (action.type){
        case 'ADD_MACHINE':
            console.log('machine added', action.machine)
            return state;
        case 'ADD_MACHINE_ERROR':
            console.log('add machine error', action.err)
            return state;

        case 'UPDATE_MACHINE':
            console.log('updated successfully', action.machine)
            return Object.assign({}, state, {
                searchedMachine: null,
                updateSuccess: true
              })
        case 'UPDATE_MACHINE_ERROR':
            console.log('update machine error', action.err)
           
        case 'SEARCH_MACHINE':
            return Object.assign({}, state, {
                searchedMachine: action.data,
                updateSuccess: false
              })
        case 'SEARCH_MACHINE_ERROR':
            console.log('Search machine error', action.err)
            return state;
        
        case 'ADD_MACHINE_MORE_INFO':
            console.log('machine more info added', action.machine)
            return Object.assign({}, state, {
                searchedMachine: null,
              })
        case 'ADD_MACHINE_MORE_INFO_ERROR':
            console.log('add machine more info error', action.err)
            return state;

        case 'GET_ALL_MACHINES':
            return Object.assign({}, state, {
                allMachines: action.data,
              })
        case 'GET_ALL_MACHINES_ERROR':
            return state;
        
        case 'RESET_SEARCH':
            return Object.assign({}, state, {
                searchedMachine: null
              });
        
        case 'RESET_ALL_MACHINES':
            return Object.assign({}, state, {
                allMachines: null
              });

        default:
            return state;
    }
}

export default machineReducer;